import Chapter from "@/components/Chapter";
import Reveal from "@/components/Reveal";
import { PROCESS } from "@/data/content";

const Process = () => (
  <section id="process" data-testid="process-section" className="bg-white py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Chapter
        index="04"
        eyebrow="Our Process"
        title="From Sampling to Shipment — Every Step Under One Roof"
        description="Our complete production process covers sampling, loom preparation, dyeing, colour correction, bulk weaving, post-production finishing, quality inspection, and final shipment—ensuring consistent quality and attention to detail at every stage."
      />
      <div className="mt-14 grid gap-px bg-navy/10 sm:grid-cols-2 lg:grid-cols-5">
        {PROCESS.map((p, i) => (
          <Reveal key={p.step} delay={i * 0.08} className="h-full">
            <div
              data-testid={`process-step-${p.title.toLowerCase().replace(/\s+/g, "-")}`}
              className="group flex h-full flex-col bg-white p-7 transition-colors duration-500 hover:bg-navy"
            >
              <span className="font-serif text-sm italic text-gold">{p.step}</span>
              <div className="gold-hairline my-5 w-12" />
              <h3 className="font-serif text-xl font-medium text-navy transition-colors duration-500 group-hover:text-white">
                {p.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-600 transition-colors duration-500 group-hover:text-slate-300">
                {p.text}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Process;
